import { IOrder, ISalesReturnResult } from "@iloq/shared";

export function filterOrders(orders: IOrder[], returns: any[]): IOrder[] {
  const orderNumbersHavingRelatedReturn: (string | undefined)[] = returns
    .filter(
      (returnItem: ISalesReturnResult) =>
        returnItem.productReturnData?.relatedOrderNumber !== undefined
    )
    .map((filteredItem: ISalesReturnResult) => filteredItem.productReturnData?.relatedOrderNumber);
  const ordersNotHavingRelatedReturn = orders.filter((order: IOrder) => {
    if (order && order.orderNumber !== undefined) {
      return !orderNumbersHavingRelatedReturn.includes(order.orderNumber);
    }
    return false;
  });
  return ordersNotHavingRelatedReturn;
}
